module.exports = __webpack_public_path__ + "img/datasets.e4ea2677.svg";